import { selectUser } from '../selectors/current_user';
import { getUser, getCSRF } from '../actions/login';

export function CSRFResource(options) {
    return {
        id: 'CSRF',
        load() {
            return options.dispatch(getCSRF());
        },
        find() {
            // Components don't actually need the csrf, we just need it loaded
            // before the app can boot.
            return null;
        },
    };
}

export function userResource(options) {
    return {
        id: 'user',
        load() {
            return options.dispatch(getUser());
        },
        find() {
            return selectUser(options.rootState);
        },
    };
}



// WEBPACK FOOTER //
// ./src/resources/current_user.js